module.exports = __webpack_public_path__ + "assets/img/thumb-Super-Obvious-Landing-Page.ab5a900d.jpg";